import React from 'react'
import cx from 'classnames'
import MuiCheckbox from '@material-ui/core/Checkbox'
import withStyles from '@material-ui/core/styles/withStyles'
import MuiTableRow from '@material-ui/core/TableRow'
import MuiTableCell from '@material-ui/core/TableCell'
import Link from '@material-ui/core/Link'
import { dismissPopover } from 'services/OverlayService'

const Checkbox = withStyles({
  root: {
    color: '#6288a5',
    '&$checked': {
      color: '#6288a5'
    }
  },
  checked: {}
})(props => <MuiCheckbox color='default' {...props} />)

export default ({
  deal,
  dealType,
  date,
  market,
  checked = 0,
  href,
  onSelect,
  showDealType,
  isLogged,
  setSignUpModalIsOpen
}) => {
  const handleOnClick = (e) => {
    dismissPopover(e.target)
    if (!isLogged) {
      e.preventDefault()
      e.stopPropagation()
      setSignUpModalIsOpen(true)
    }
  }
  const isChecked = checked > 0

  return (
    <MuiTableRow
      hover={!isChecked}
      classes={{
        root: cx('bg-ghost-grey', {
          'bg-pearl-lusta': isChecked
        })
      }}
    >
      <MuiTableCell padding='checkbox' classes={{ root: 'dn-l dn-d' }}>
        <RowCheckbox {...{ checked, onSelect }} />
      </MuiTableCell>
      <MuiTableCell classes={{ root: 'min-w12 f7-m' }}>
        <Link
          className='pointer'
          href={isLogged ? href : null}
          onClick={handleOnClick}
        >
          {deal}
        </Link>
      </MuiTableCell>
      <MuiTableCell classes={{ root: 'f7-m' }}>
        {date}
      </MuiTableCell>
      {showDealType && (
        <MuiTableCell>
          <div className='f7-m no-wrap w-max-content'>{dealType}</div>
        </MuiTableCell>
      )}
      <MuiTableCell classes={{ root: 'f7-m' }}>{market}</MuiTableCell>
      <MuiTableCell padding='checkbox' classes={{ root: 'dn-t' }}>
        <RowCheckbox {...{ checked, onSelect }} />
      </MuiTableCell>
    </MuiTableRow>

  )
}

const RowCheckbox = ({ checked, onSelect }) => (
  <Checkbox
    checked={checked === 1}
    disabled={checked === -2}
    onChange={onSelect}
    value='checkedA'
    data-hover-popover-content={checked === -2 ? "Can't select deal of a different type" : undefined}
  />
)
